export default state => state.category.gender;
